module.exports = function () {
    'use strict';
    function Cue(time, type, id) {
        this.time = time;
        this.type = type;
        this.id = id;
    }
    Cue.POINT = 0;
    Cue.SEGMENT_START = 1;
    Cue.SEGMENT_END = 2;
    Cue.sorter = function (a, b) {
        return a.time - b.time;
    };
    return Cue;
}();